<template>
  <!-- 服务协议管理 -->
  <div class="containerbox serverContent">
    <div class="formcontent">
      <el-form ref="form" :model="formData" :rules="rules" label-width="114px">
        <div class="topSelect">
          <el-form-item
            class="tit_formItems"
            label="文章类型"
            prop="articleTypeId"
          >
            <el-select
              :popper-append-to-body="false"
              v-model="formData.articleTypeId"
              placeholder="请选择"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in articleTypeList"
                :label="item.articleTypeName"
                :value="item.articleTypeId + ''"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="tit_formItems" label="前端可见">
            <el-select
              :popper-append-to-body="false"
              v-model="formData.isPopUp"
              placeholder="请选择"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in isNoList"
                :label="item.label"
                :value="item.value"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="文章标题" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>

        <div class="contentBox">
          <el-form-item label="文章内容" prop="content">
            <div :id="'eidtContent_' + formData.contents[0].languageCode"></div>
          </el-form-item>
        </div>

        <el-form-item style="text-align: center">
          <el-button @click="gobackPage()" style="margin-right: 50px"
            >关闭页面</el-button
          >
          <el-button v-if="isDetails" type="warning" @click="addServe"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
      <div style="height: 10px; width: 100%"></div>
    </div>
  </div>
</template>

<script>
// import { this.$API } from "@/assets/js/api";
// import paging from "@/components/pagings.vue";
import E from "wangeditor";

export default {
  inject: ["reload"],

  data() {
    return {
      editor_en: {},
      formData: {
        articleTypeId: "",
        appShow: 1,
        isPopUp: 0,
        officialWebsiteShow: 1,
        contents: [
          {
            content: "",
            languageCode: "zh-CN",
            title: "",
            editor: {},
          },
        ],
      },
      rules: {
        articleTypeId: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"],
          },
        ],
        officialWebsiteShow: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        appShow: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        title: [{ required: true, message: "", trigger: "blur" }],
        // content: [{ required: true, message: "", trigger: "blur" }],
        // cnContent: [{ required: true, message: "请输入", trigger: "blur" }],
        // enContent: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      pageNum: 1, //页码
      size: 50, //一页几条,
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      tableData: [], //表格数据
      tableHeigth: 0,
      selectMemberData: [],
      articleTypeList: [], //类型下拉列表
      isNoList: [
        {
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      isDetails: true, //false==详情页面,不显示修改按钮
      languageCodeList: [
        {
          code: "zh-CN",
          name: "中文",
        },
        {
          code: "en",
          name: "英文",
        },
      ],
      langCodeList: ["zh-CN"],
      CurrentLanguage: "", //当前语言
      visible: false,
      isSHowDel: false,
    };
  },
  components: {
    // paging,
  },
  updated() {},
  created() {},
  mounted() {
    // this.getTypeList();
    this.initLangeuage(0, "zh-CN");
  },
  activated() {
    let querys = this.$route.query;
  },
  watch: {},
  methods: {
    // 删除语种
    delLange(index, languageCode) {
      this.formData.contents.splice(index, 1);
      this.langCodeList.splice(this.langCodeList.indexOf(languageCode), 1);
      this.isSHowDel = false;
    },
    // 新增语种
    conFirmLange() {
      if (!this.CurrentLanguage) {
        this.$message.warning("请选择语种");
        return false;
      }
      if (this.langCodeList.indexOf(this.CurrentLanguage) !== -1) {
        this.$message.warning("该语言已存在");
        return false;
      }
      this.langCodeList.push(this.CurrentLanguage);
      let obj = {
        content: "",
        languageCode: this.CurrentLanguage,
        title: "",
        editor: {},
      };
      this.formData.contents.push(obj);
      this.visible = false;
      this.$nextTick(() => {
        this.initLangeuage(this.formData.contents.length - 1, obj.languageCode);
      });
      this.CurrentLanguage = "";
    },

    //   初始化富文本编辑器
    initE() {
      this.formData.contents.forEach((item, index) => {
        console.log(index);
        item.editor = new E("#eidtContent_" + item.languageCode);
        console.log("item.editor");
        console.log(item.editor);
        item.editor.config.height = 600; //富文本高度
        // 编辑器菜单栏配置
        item.editor.config.menus = [
          "head", // 标题
          "bold", // 粗体
          "fontSize", // 字号
          "indent", //缩进
          "fontName", // 字体
          "italic", // 斜体
          "underline", // 下划线
          "strikeThrough", // 删除线
          "foreColor", // 文字颜色
          "backColor", // 背景颜色
          "link", // 插入链接
          "list", // 列表
          "justify", // 对齐方式
          "quote", // 引用
          "emoticon", // 表情
          "table", // 表格
          "code", // 插入代码
          "undo", // 撤销
          "redo", // 重复
        ];
        item.editor.create();
      });
    },

    initLangeuage(index, languageCode) {
      this.formData.contents[index].editor = {};
      this.formData.contents[index].editor = new E(
        "#eidtContent_" + languageCode
      );
      this.formData.contents[index].editor.config.height = 500; //富文本高度
      // 编辑器菜单栏配置
      this.formData.contents[index].editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "indent", //缩进
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];
      this.formData.contents[index].editor.create();
    },

    addServe() {
      //新增协议 保存接口
      let newcontents = [];
      this.formData.contents.forEach((item) => {
        let obj = {
          content: item.editor.txt.html(),
          languageCode: item.languageCode,
          title: item.title,
        };
        newcontents.push(obj);
      });
      let param = {
        appShow: this.formData.appShow,
        articleTypeId: this.formData.articleTypeId,
        isPopUp: this.formData.isPopUp,
        officialWebsiteShow: this.formData.officialWebsiteShow,
        contents: newcontents,
      };
      console.log(param);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$API.addArticle(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success("新建成功");
              this.gobackPage();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 类型下拉
    getTypeList() {
      this.$API
        .articleTypeChooseList({
          // articleCategory: "gong_lue:article_category",
          articleCategory: "xi_tong:article_category",
        })
        .then((res) => {
          this.articleTypeList = res.data.result || [];
        });
    },
    gobackPage() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/SystemSetting/ArticleManagement",
        query: {
          isreload: "isreload",
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.formcontent {
  max-width: 1000px;
  margin: 0 auto;

  .topSelect {
    display: flex;
    align-items: center;
    .tit_formItems {
      width: 45%;
      margin-right: 2%;
    }

    /deep/ .el-select-dropdown {
      z-index: 10003 !important;
    }
  }

  .contentBox {
    border: 1px dashed #d7d7d7;
    padding: 20px;
    margin-bottom: 20px;
  }
}
.containerbox {
  // height: calc(100vh - 61px);
  height: 100vh;
  padding: 16px;
}

.tableBox {
  height: calc(100% - 260px);
}
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  // display: flex;
  // justify-content: center;

  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    padding: 10px;
    border-radius: 4px;
  }
}

.addDelBtns {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
